export const linkedinposts24: string[] = [
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7188957114109673472?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7199356996272226304?collapsed=1"
]

